exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-2465cfc4]{min-height:50px;width:calc(100% - 20px);padding:0 10px;background-color:#584d70}p[data-v-2465cfc4]{margin:15px 0;color:#fff}img[data-v-2465cfc4]{margin:0 15px}.christopheds[data-v-2465cfc4]{height:30px;margin:10px 15px}.alpitech[data-v-2465cfc4]{height:40px;margin:5px 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2465cfc4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 182
// module chunks = 0